import { useState, useEffect } from 'react';

interface Message {
  role: string;
  content: string;
  timestamp: Date;
}

interface GameAttempt {
  id: string;
  messages: Message[];
  securityScore: number;
  success: boolean;
  startTime: Date;
  endTime: Date;
  cost: number;
  tokensSpent: number;
  messageCount: number;
}

export const useAttempts = () => {
  const [attempts, setAttempts] = useState<GameAttempt[]>([]);
  const [totalAttempts, setTotalAttempts] = useState<number>(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchAttempts = async () => {
      try {
        setLoading(true);
        // Fetch recent attempts
        const attemptsResponse = await fetch(`${import.meta.env.VITE_API_BASE_URL}/api/attempts/recent`);
        if (!attemptsResponse.ok) {
          throw new Error('Failed to fetch attempts');
        }
        const attemptsData = await attemptsResponse.json();
        setAttempts(attemptsData);

        // Fetch total attempts
        const totalResponse = await fetch(`${import.meta.env.VITE_API_BASE_URL}/api/total-attempts`);
        if (!totalResponse.ok) {
          throw new Error('Failed to fetch total attempts');
        }
        const totalData = await totalResponse.json();
        setTotalAttempts(totalData.totalAttempts);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to load attempts');
        console.error('Error fetching attempts:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchAttempts();
  }, []);

  return { attempts, totalAttempts, loading, error };
}; 